<template>
  <div
    class="app-button__switch"
    :class="[{ 'app-button__switch--light': !dark }]"
  >
    <slot name="buttons" />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  dark?: boolean
}>()
</script>
